import {isSet,isEmpty,source} from './utils/common'
export function loanTransferCalc(){
	if(validateLoanTransferForm()){
		document.getElementById('spinner').classList.remove('hidden');
		//ajax
		$.ajax({
            url: "/homes/re2/homeloanTransferCalc?aj=1",
            type: "POST",
            data: {'homeloanTransferCalc' : JSON.stringify(homeloancalc.loanTransferCalc)},
            success: function (data) {
                if(!isEmpty(data)){
                	document.getElementById('spinner').classList.add('hidden');
                	document.getElementById('hl_loan_transfer_response').classList.remove('opacity_otp');
                	let interestDiff = data['differenceInInterest'];
                	let lt_save = '';
                	let lt_save_interest = '';
                	let lt_int_amount = 'in interest amount.';
                	if(interestDiff > 0){
                		lt_save = 'You will save';
                		lt_save_interest = ' &#8377; '+ interestDiff;
                	}else {
                		lt_save = 'You will spend';
                		lt_save_interest = ' &#8377; '+ (interestDiff * -1);
                		lt_int_amount = 'additionally '+ lt_int_amount;
                	}
                	document.getElementById('lt_save').innerHTML = lt_save;
                	document.getElementById('lt_save_interest').innerHTML = lt_save_interest;
                	document.getElementById('lt_int_amount').innerHTML = lt_int_amount;

                	let tenureDiff = data['differenceInTenure'];
                	let emiTenureText = '';
                	if(tenureDiff > 0){
                		emiTenureText = 'EMI Tenure will be reduced by ' + tenureDiff +' Months';
                	}else {
                		emiTenureText = 'EMI Tenure will be increased by ' + (tenureDiff * -1) +' Months';
                	}
                	document.getElementById('lt_emi_tenure_diff').innerHTML = emiTenureText;
                	
                	let currentResp = data['homeLoanTransferCurrentLoanResponse'];
                	document.getElementById('lt_emi_per_month').innerHTML = '&#8377; ' + currentResp['emi'];
                    document.getElementById('lt_principal_outstndg').innerHTML = '&#8377; ' + currentResp['outstandingBalance'];
                    document.getElementById('lt_emi_tenure').innerHTML = currentResp['emiTenureInMonths'] + ' Months';
                    document.getElementById('lt_interest').innerHTML = '&#8377; ' + currentResp['totalInterest'];
                    let newResp = data['homeLoanTransferNewLoanResponse'];
                    document.getElementById('lt_emi_tenure_new').innerHTML = newResp['emiTenureInMonths'] + ' Months';
                    document.getElementById('lt_total_interest').innerHTML = '&#8377; ' + newResp['totalInterest'];
                }else{
                	document.getElementById('spinner').classList.add('hidden');
                    document.getElementById('error_message').innerHTML = 'Request not found. Please try again by changing values.';
                    document.getElementById('hc_error_popup').click();
                    return false;
                }
            } 
        });
	}else {
		return false;
	}
}

export function resetTransferLoanForm(){
	document.getElementById('lt_loan_amount').value = '';
	document.getElementById('lt_loan_amount_price').innerHTML = '';
	document.getElementById('lt_rate_of_interest').value = '';
	document.getElementById('lt_rate_of_interest_price').innerHTML = '';
	document.getElementById('lt_installments_paid').value = '';
	document.getElementById('lt_installments_paid_price').innerHTML = '';
	document.getElementById('lt_loan_tenure_year').value = '';
	document.getElementById('lt_loan_tenure_month').value = '';
	document.getElementById('lt_processing_fee').value = '';
	document.getElementById('lt_processing_fee_price').innerHTML = '';
	document.getElementById('lt_new_rate_of_interest').value = '';
	document.getElementById('lt_new_rate_of_interest_price').innerHTML = '';
	document.getElementById('lt_new_loan_tenure_year').value = '';
	document.getElementById('lt_new_loan_tenure_month').value = '';
	document.getElementById('hl_loan_transfer_response').classList.add('opacity_otp');
	document.getElementById('lt_save').innerHTML = 'You will save ';
	document.getElementById('lt_save_interest').innerHTML = '&#8377; 00.00 ';
	document.getElementById('lt_int_amount').innerHTML = 'in interest amount.';
	document.getElementById('lt_emi_tenure_diff').innerHTML = 'EMI Tenure will be reduced by 0 Months';
	document.getElementById('lt_emi_per_month').innerHTML = '&#8377; 00.00';
    document.getElementById('lt_principal_outstndg').innerHTML = '&#8377; 00.00';
    document.getElementById('lt_emi_tenure').innerHTML = ' Months';
    document.getElementById('lt_interest').innerHTML = '&#8377; 00.00';
    document.getElementById('lt_emi_tenure_new').innerHTML = ' Months';
    document.getElementById('lt_total_interest').innerHTML = '&#8377; 00.00';
}

function validateLoanTransferForm(){
	let isEmiFormValid = false;
	//Loan Transfer loan amount check..
	if(isTransferLoanAmountValid()) {
		isEmiFormValid = true;
	} else{
		isEmiFormValid = false;
	}
	//Loan Transfer loan tenure year and month check
	if(isLoanTransferTenureValid()){
		isEmiFormValid = true;
	} else{
		isEmiFormValid = false;
	}
	//Loan Transfer loan tenure year and month check
	if(isLoanTransferTenureNewValid()){
		isEmiFormValid = true;
	} else{
		isEmiFormValid = false;
	}
	//Loan Transfer rate of interest check
	if(isTransferLoanRateOfInterestValid()){
		isEmiFormValid = true;
	} else{
		isEmiFormValid = false;
	}
	//Loan Transfer processing fee check
	if(isProcessingFeeValid()){
		isEmiFormValid = true;
	} else{
		isEmiFormValid = false;
	}
	//Loan Transfer rate of interest check
	if(isTransferLoanNewRateOfInterestValid()){
		isEmiFormValid = true;
	} else{
		isEmiFormValid = false;
	}
	//Loan Transfer installment check
	if(isLoanTransferInstallmentsValid()) {
		isEmiFormValid = true;
	} else{
		isEmiFormValid = false;
	}
	return isEmiFormValid;
}

function isTransferLoanAmountValid() {
	let lt_loan_amount = document.getElementById('lt_loan_amount').value;
	let regex = /^[0-9, ]+$/i;
	if(lt_loan_amount.match(regex) && lt_loan_amount !='') {
		HomeLoanCalculator.hideError('lt_loan_amount_error');
		homeloancalc.loanTransferCalc.lt_loan_amount = lt_loan_amount.replace(/,/g, '');
		return true;
	} else {
		let msg = "Enter valid loan amount";
		HomeLoanCalculator.showError('lt_loan_amount_error', msg);
		return false;
	}
}

export function isLoanTransferTenureNewValid() {
	let tenure_year = document.getElementById('lt_new_loan_tenure_year').value;
	let tenure_month = document.getElementById('lt_new_loan_tenure_month').value;
	if(tenure_year == '' && tenure_month == ''){
		let msg = "Enter valid loan tenure years or months";
		HomeLoanCalculator.showError('lt_new_loan_tenure_error', msg);
		return false;
	}else if(tenure_year != '' && tenure_month == ''){
		isLoanTransferNewTenureYearValid(tenure_year);
	}else if(tenure_month != '' && tenure_year == ''){
		isLoanTransferNewTenureMonthValid(tenure_month);
	}else {
		let YearTenure = isLoanTransferNewTenureYearValid(tenure_year);
		let MonthTenure = isLoanTransferNewTenureMonthValid(tenure_month);
		if(YearTenure && MonthTenure){
			HomeLoanCalculator.hideError('lt_new_loan_tenure_error');
			return true;
		}else if(!YearTenure){
			let msg = "Enter valid loan tenure years";
			HomeLoanCalculator.showError('lt_new_loan_tenure_error', msg);
		}else if(!MonthTenure){
			let msg = "Enter valid loan tenure months";
			HomeLoanCalculator.showError('lt_new_loan_tenure_error', msg);
		}
	}
}

function isLoanTransferNewTenureYearValid(tenure_year) {
	let regex = /^[0-9, ]+$/i;
	if(tenure_year.match(regex) && tenure_year !='') {
		HomeLoanCalculator.hideError('lt_new_loan_tenure_error');
		homeloancalc.loanTransferCalc.tenure_year_new = tenure_year.replace(/,/g, '');
		return true;
	} else {
		document.getElementById('lt_new_loan_tenure_year').value = '';
		let msg = "Enter valid loan tenure years";
		HomeLoanCalculator.showError('lt_new_loan_tenure_error', msg);
		return false;
	}
}

function isLoanTransferNewTenureMonthValid(tenure_month) {
	let regex = /^[0-9 ]+$/i;
	if(tenure_month !='' && tenure_month.match(regex) && tenure_month >= 0 && tenure_month < 12) {
		HomeLoanCalculator.hideError('lt_new_loan_tenure_error');
		homeloancalc.loanTransferCalc.tenure_month_new = tenure_month;
		return true;
	} else {
		document.getElementById('lt_new_loan_tenure_month').value = '';
		let msg = "Enter valid loan tenure months";
		HomeLoanCalculator.showError('lt_new_loan_tenure_error', msg);
		return false;
	}
}

export function isLoanTransferTenureValid() {
	let tenure_year = document.getElementById('lt_loan_tenure_year').value;
	let tenure_month = document.getElementById('lt_loan_tenure_month').value;
	if(tenure_year == '' && tenure_month == ''){
		let msg = "Enter valid loan tenure years or months";
		HomeLoanCalculator.showError('lt_loan_tenure_error', msg);
		return false;
	}else if(tenure_year != '' && tenure_month == ''){
		isLoanTransferTenureYearValid(tenure_year);
	}else if(tenure_month != '' && tenure_year == ''){
		isLoanTransferTenureMonthValid(tenure_month);
	}else {
		let YearTenure = isLoanTransferTenureYearValid(tenure_year);
		let MonthTenure = isLoanTransferTenureMonthValid(tenure_month);
		if(YearTenure && MonthTenure){
			HomeLoanCalculator.hideError('lt_loan_tenure_error');
			return true;
		}else if(!YearTenure){
			let msg = "Enter valid loan tenure years";
			HomeLoanCalculator.showError('lt_loan_tenure_error', msg);
		}else if(!MonthTenure){
			let msg = "Enter valid loan tenure months";
			HomeLoanCalculator.showError('lt_loan_tenure_error', msg);
		}
	}
		
}

function isLoanTransferTenureYearValid(tenure_year) {
	let regex = /^[0-9, ]+$/i;
	if(tenure_year.match(regex) && tenure_year !='') {
		HomeLoanCalculator.hideError('lt_loan_tenure_error');
		homeloancalc.loanTransferCalc.tenure_year = tenure_year.replace(/,/g, '');
		return true;
	} else {
		document.getElementById('lt_loan_tenure_year').value = '';
		let msg = "Enter valid loan tenure years";
		HomeLoanCalculator.showError('lt_loan_tenure_error', msg);
		return false;
	}
}

function isLoanTransferTenureMonthValid(tenure_month) {
	let regex = /^[0-9 ]+$/i;
	if(tenure_month !='' && tenure_month.match(regex) && tenure_month >= 0 && tenure_month < 12) {
		HomeLoanCalculator.hideError('lt_loan_tenure_error');
		homeloancalc.loanTransferCalc.tenure_month = tenure_month;
		return true;
	} else {
		document.getElementById('lt_loan_tenure_month').value = '';
		let msg = "Enter valid loan tenure months";
		HomeLoanCalculator.showError('lt_loan_tenure_error', msg);
		return false;
	}
}

function isLoanTransferInstallmentsValid() {
	let lt_installments_paid = document.getElementById('lt_installments_paid').value;
	let regex = /^[0-9]+$/i;
	if(lt_installments_paid.match(regex) && lt_installments_paid !='') {
		HomeLoanCalculator.hideError('lt_installments_paid_error');
		homeloancalc.loanTransferCalc.lt_installments_paid = lt_installments_paid.replace(/,/g, '');
		return true;
	} else {
		let msg = "Enter valid installments paid";
		HomeLoanCalculator.showError('lt_installments_paid_error', msg);
		return false;
	}
}

function isTransferLoanRateOfInterestValid() {
	let lt_rate_of_interest = document.getElementById('lt_rate_of_interest').value;
	let regex = /^[0-9. ]+$/i;
	if(lt_rate_of_interest.match(regex) && lt_rate_of_interest !='') {
		HomeLoanCalculator.hideError('lt_rate_of_interest_error');
		homeloancalc.loanTransferCalc.lt_rate_of_interest = lt_rate_of_interest.replace(/,/g, '');
		return true;
	} else {
		let msg = "Enter valid rate of interest";
		HomeLoanCalculator.showError('lt_rate_of_interest_error', msg);
		return false;
	}
}

function isProcessingFeeValid() {
	let lt_processing_fee = document.getElementById('lt_processing_fee').value;
	let regex = /^[0-9. ]+$/i;
	if(lt_processing_fee.match(regex) && lt_processing_fee !='') {
		HomeLoanCalculator.hideError('lt_processing_fee_error');
		homeloancalc.loanTransferCalc.lt_processing_fee = lt_processing_fee.replace(/,/g, '');
		return true;
	} else {
		let msg = "Enter valid rate of interest";
		HomeLoanCalculator.showError('lt_processing_fee_error', msg);
		return false;
	}
}

function isTransferLoanNewRateOfInterestValid() {
	let lt_new_rate_of_interest = document.getElementById('lt_new_rate_of_interest').value;
	let regex = /^[0-9. ]+$/i;
	if(lt_new_rate_of_interest.match(regex) && lt_new_rate_of_interest !='') {
		HomeLoanCalculator.hideError('lt_new_rate_of_interest_error');
		homeloancalc.loanTransferCalc.lt_new_rate_of_interest = lt_new_rate_of_interest.replace(/,/g, '');
		return true;
	} else {
		let msg = "Enter valid rate of interest";
		HomeLoanCalculator.showError('lt_new_rate_of_interest_error', msg);
		return false;
	}
}


